import { UserPointsUpdate } from "./user";

export type VariantType = "a" | "b" | "c" | "d" | "e";

export type VariantStatus = {
  variant_id: VariantType;
  enabled: boolean;
  result: number;
  previousResult: number;
};

export type LevelStatus = {
  level_id: string;
  enabled: boolean;
  variants: VariantStatus[];
};

export type CategoryStatus = {
  category_id: string;
  levels: LevelStatus[];
};

export type CategoryUpdate = {
  categoryUpdate: CategoryStatus;
  userPointsUpdate: UserPointsUpdate;
};

export type VariantSignature = {
  category_id: string;
  level_id: string;
  variant_id: VariantType;
};

export type VariantFull = {
  category_id: string;
  level_id: string;
  variant_id: VariantType;
  variant: VariantStatus;
  level: LevelStatus;
  category: CategoryStatus;
};

export enum UpdateType {
  STORAGE = "STORAGE",
  SERVER = "SERVER",
  LOCAL = "LOCAL",
}

export interface CategoryStatusAppData {
  data: CategoryStatus[];
  lastUpdateType: UpdateType;
}
